import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { STORAGE_KEYS } from 'legacy/common/constants/storage';
import storage from 'legacy/common/utils/storage';
import { attemptInitialJwtLogin } from 'legacy/actions/userActions';
import withAuthRedirect from 'legacy/auth/hoc/withAuthRedirect';

interface Props {
  Component: React.ComponentType<unknown>;
  pageProps: any;
}

function WebViewWrapper({ Component, pageProps }: Props) {
  const router = useRouter();

  // Make sure the current session, if any, is being applied.
  // Consumer still needs to check for auth state in their own component if needed.
  // This gives the flexibility to the consumer to handle auth state based on their context.
  // For example, forms loaded in webview need to potentially be able to load without auth.
  useEffect(() => {
    const token = storage.getItem(STORAGE_KEYS.AUTH_TOKEN);
    document.cookie = `token=${token}; path=/`;
    attemptInitialJwtLogin({
      isAuthenticated: !!token
    });
  }, []);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component router={router} {...pageProps} />;
}

const mapStateToProps = (state) => ({
  user: state.user.user,
  userLoading: state.user.loading
});

export default connect(mapStateToProps, { attemptInitialJwtLogin })(
  withAuthRedirect(WebViewWrapper)
);
